const captainsTips = () => {
    const allCaptainTips = Array.from(document.querySelectorAll('.captains__captain--tip-link'));

    if (allCaptainTips.length > 0) {
        allCaptainTips.forEach(tip => {
            tip.addEventListener('click', (e) => {
                e.preventDefault();
                const closestTip = e.target.closest('.captains__captain--tip-link')
                const tipID = closestTip.dataset.tooltip;
                const tipShow = document.getElementById(`${tipID}`);

                if (tipShow.classList.contains('show-tip')) {
                    closestTip.classList.remove('tip-shown');
                    tipShow.classList.remove('show-tip');
                } else {
                    closestTip.classList.add('tip-shown');
                    tipShow.classList.add('show-tip');
                }
            })
        })
    }
}

export default captainsTips;